export default __webpack_public_path__ + "static/wallpaper-8-mb-72ab9ab63d1482f2a1ce2bb4a1fd5e63.png";